import {LifeProject} from './life-project';
import {AbstractAsset} from '../abstract-asset';
import {AssetResource} from './asset-resource';

export class FinantialProject extends LifeProject {
  neededValue: number;
  importValue: number;
  rate: number;
  monthValue: number;
  savedMoney: number;
  projectTarget: number;
  type = 4;
}
